import { API_ROUTES } from '@shared/api-utils';
import { ROUTES, useClientConfig } from '@shared/utils';
import { useCallback } from 'react';
import { setAuthPendingCallback } from '../helpers/authPendingCallback';

type SignInOptions = { callbackUrl?: string };
type SignInFn = (options?: SignInOptions) => void;

function useSignIn(): SignInFn {
  const { baseUrl } = useClientConfig();
  return useCallback(
    (options?: SignInOptions) => {
      const callbackUrl = options?.callbackUrl ?? ROUTES.HOME;
      const redirectUri = options?.callbackUrl ? new URL(options.callbackUrl, baseUrl).toString() : ROUTES.HOME;
      const loginUrl = new URL(`${baseUrl}${API_ROUTES.MY_ACCOUNT.PLAYER_AUTH.LOGIN}`);
      loginUrl.searchParams.set('redirectUri', redirectUri);

      setAuthPendingCallback(callbackUrl);
      window.location.href = loginUrl.href;
    },
    [baseUrl]
  );
}

export { useSignIn };
